import React, { useEffect } from 'react'

export default function Betingelser() {
  useEffect(() => {
    document.title = 'Betingelser vedr. køreskole til elever fra Kalundborg | Tilmeld dig i dag'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Almindelige forretningsbetingelser for Borgs køreskole. Læs mere om undervisning, betaling, ændret forløb og prøver.'
      )
    }
  }, [])

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 sm:p-12 border border-slate-200 shadow-sm space-y-8">
          <div>
            <h1 className="font-header text-3xl sm:text-4xl font-extrabold text-slate-900">
              Betingelser
            </h1>
            <p className="mt-2 text-slate-700 font-semibold text-lg">
              Almindelige forretningsbetingelser for Borgs køreskole
            </p>
          </div>

          <div className="space-y-6 text-slate-700 leading-relaxed">
            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                1. Undervisning
              </h2>
              <p>
                Eleven deltager aktivt i undervisningen, ved personligt fremmøde til såvel teorilektioner som praktiske lektioner.
              </p>
              <p>
                Hvis eleven ikke kan møde op til den teoretiske undervisning meddeles dette skolen/læreren, loven åbner mulighed for at eleven kan tage 1 teoriaften som selvstudium.
              </p>
              <p>
                Da loven foreskriver at teoriundervisning skal afholdes som klasse undervisning er det derfor vigtigt at eleven møder op til teoriundervisning
              </p>
              <p>
                Eleven aftaler i samråd med kørelæreren hvornår de praktiske lektioner skal foregå, samt hvor fra køreselen skal starte/slutte
              </p>
              <p>
                Afbud til praktiske lektioner kan ske dagen før senest kl. 1200 uden betaling for lektionen(er)
              </p>
              <p>
                Der henvises til bagsiden på lektionsplanen for konsekvenser af pause i køre uddannelsen.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                2. Betaling
              </h2>
              <p>
                Betaling sker efter fremsendt / udleveret faktura
              </p>
              <p>
                Undervisningen betales normalt i rater <strong>alle faktura skal være betalt, inden praktisk prøve kan afholdes.</strong> Alle priser er inkl. Moms.
              </p>
              <p>
                Prøvegebyr er dog momsfrit.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                3. Ændret / afbrudt forløb
              </h2>
              <p>
                Ved ændret /afbrudt forløb tilbagebetales pengene for den del af undervisning som eleven ikke har modtaget.
              </p>
              <p>
                Såfremt eleven har modtaget undervisning som ikke er forudbetalt, udleveres lektionsplanen kun efter afregning for modtaget undervisning.
              </p>
              <p>
                Ved rabat på lovpakker betragtes rabatten som værende de sidste lektioner uden beregning. Såfremt der opstår tvist imellem eleven og køreskolen kan eleven klage til ankenævnet for køreundervisning, det koster 150 kr. at klage pengene refunderes hvis eleven for medhold.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                4. Tidspunkter for prøver, afvikling af prøver
              </h2>
              <p>
                Disse tider afgøres af færdselsstyrelsen og de er normalt ikke til at ændre efter bestilling.
              </p>
              <p>
                Køreskolen/ kørelæren afgør hvornår en elev er klar til teori/praktisk prøve.
              </p>
              <p>
                Køreskolen kan ikke holdes ansvarlig for ventetider på teoretisk / praktisk prøve, eller manglende godkendelse af lægeerklæring. Såfremt en elev ikke består teoriprøver eller praktisk prøver kan køreskolen ikke holdes ansvarlig.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                5. Indstilling til prøve
              </h2>
              <p>
                Køreskolen sørger for berammelse af prøve(r) hos færdselsstyrelsen.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
